import { Constants, IModalState, ModalActionTypes } from './types'

const initialState: IModalState = {
  type: null,
  multiple: false,
  disable: false,
}

export function modalReducer(
    state = initialState,
    action: ModalActionTypes,
): IModalState {
  switch (action.type) {
    case Constants.SET_DISABLE:
      return {
        ...state,
        disable: action.payload,
      }
    case Constants.SET_MODAL:
      return {
        ...state,
        type: action.payload,
      }
    case Constants.SET_MULTIPLE_MODAL:
      return {
        ...state,
        multiple: action.payload,
      }
    default:
      return state
  }
}

export default modalReducer
